// apps/web/src/components/message-list.tsx
import { useEffect, useRef } from 'react'
import { ScrollArea } from '@viecxanh/chat-ui/scroll-area'
import { Button } from '@viecxanh/chat-ui/button'
import { Skeleton } from '@viecxanh/chat-ui/skeleton'
import { MessageBubble } from './message-bubble'
import { useMessages } from '../hooks/use-messages'
import { useAuth } from '../hooks/use-auth'
import type { Message } from '@viecxanh/chat-shared'

interface MessageListProps {
  conversationId: string
}

export function MessageList({ conversationId }: MessageListProps) {
  const { messages, hasMore, isLoading, loadMore } = useMessages(conversationId)
  const { staff } = useAuth()
  const bottomRef = useRef<HTMLDivElement>(null)
  const prevLengthRef = useRef(0)

  useEffect(() => {
    if (messages.length > prevLengthRef.current) {
      bottomRef.current?.scrollIntoView({ behavior: 'smooth' })
    }
    prevLengthRef.current = messages.length
  }, [messages.length])

  if (isLoading) {
    return (
      <div className="flex flex-col gap-3 p-4">
        {Array.from({ length: 6 }).map((_, i) => (
          <Skeleton key={i} className={`h-10 w-2/3 ${i % 2 === 0 ? '' : 'self-end'}`} />
        ))}
      </div>
    )
  }

  return (
    <ScrollArea className="flex-1 px-4">
      {hasMore && (
        <div className="flex justify-center py-2">
          <Button variant="ghost" size="sm" onClick={loadMore}>
            Tải thêm
          </Button>
        </div>
      )}

      {messages.map((msg: Message) => (
        <MessageBubble
          key={msg._id}
          message={msg}
          isOwn={msg.sender.user_type === 'staff' && msg.sender.user_id === staff?.id}
        />
      ))}

      <div ref={bottomRef} />
    </ScrollArea>
  )
}
